import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'aa-section-t1',
    templateUrl: './section-t1.component.html',
    styleUrls: [
        './section-t1.component.scss'
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SectionT1Component
{
}
